import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class LangPaginatorIntl {
  paginationTrnaslate: any;
  constructor(private readonly translate: TranslateService) {
    this.translate.get(['GLOBAL.PAGINATION']).subscribe(res => {
      this.paginationTrnaslate = res['GLOBAL.PAGINATION'];
    });
  }

  public getLangPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = this.translate.instant('GLOBAL.PAGINATION.ITEMS_PER_PAGE_LABEL') || this.paginationTrnaslate['ITEMS_PER_PAGE_LABEL'];
    paginatorIntl.nextPageLabel = this.translate.instant('GLOBAL.PAGINATION.NEXT_PAGE_LABEL') || this.paginationTrnaslate['NEXT_PAGE_LABEL'];
    paginatorIntl.previousPageLabel = this.translate.instant('GLOBAL.PAGINATION.PREVIOUS_PAGE_LABEL') || this.paginationTrnaslate['PREVIOUS_PAGE_LABEL'];
    paginatorIntl.firstPageLabel = this.translate.instant('GLOBAL.PAGINATION.FIRST_PAGE_LABEL') || this.paginationTrnaslate['FIRST_PAGE_LABEL'];
    paginatorIntl.lastPageLabel = this.translate.instant('GLOBAL.PAGINATION.LAST_PAGE_LABEL') || this.paginationTrnaslate['LAST_PAGE_LABEL'];
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    return paginatorIntl;
  }

  private getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('GLOBAL.PAGINATION.RANGE_PAGE_LABEL_1', { length });
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return this.translate.instant('GLOBAL.PAGINATION.RANGE_PAGE_LABEL_2', { startIndex: startIndex + 1, endIndex, length });
  }
}
